<template>
  <div class="py-5 pr-3 flex flex-col justify-between">

    <div>
      <div class="flex justify-between">
        <div>
          <strong>Cart</strong>
          <div class="text-neutral-500 mb-15">
            {{ quantity }} products
          </div>
        </div>
        <cart-close @close="() => emit('close')" />
      </div>
      <cart-item
          v-for="(item, index) in lines"
          :key="index"
          :item="item"
      />

      <cart-shipping v-if="!empty"/>
      <cart-total v-if="!empty"/>
    </div>

    <product-button v-if="!empty" class="my-10 cursor-pointer mb-20" @click="() => emit('checkout')">CHECKOUT</product-button>

  </div>
</template>

<script lang="ts" setup>
import {useCartStore} from "~/store/cart";

const store = useCartStore();
const {quantity, lines, empty} = storeToRefs(store)
const emit = defineEmits<{
  close: [void],
  checkout: [void]
}>()

</script>